import awsconfig from '@/aws-exports';

export default async function (authCode) {
  const params = new URLSearchParams({
    grant_type: 'authorization_code',
    redirect_uri: awsconfig.oauth.redirectSignIn,
    client_id: awsconfig.aws_user_pools_web_client_id,
    code: authCode,
  });

  // Exchange authorization code for tokens
  const res = await fetch(
    `https://${awsconfig.oauth.domain}/oauth2/token`,
    {
      method: 'POST',
      body: params,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    },
  )
    .then(async (response) => {
      // check for error response
      if (!response.ok) {
        // get error message from body or default to response status
        return Promise.reject(response);
      }

      const data = await response.json();

      return Promise.resolve(data);
    })
    .catch(error => Promise.reject(error));

  return res;
}
